module.exports = __webpack_public_path__ + "static/media/profile-3.ca285b01.png";